import { configureStore } from '@reduxjs/toolkit';
import { shallowEqual, type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import context from '@alltrails/context/slices/contextSlice';
import { experimentsReducer } from '@alltrails/experiments';
import userConnectionLists from '@alltrails/redux/slices/userConnectionLists';
import userConnections from '@alltrails/redux/slices/userConnections';
import type Context from '@alltrails/types/Context';
import lists from '../slices/lists';

export type PreloadedState = {
  context: Context;
};

const reducer = {
  context,
  experiments: experimentsReducer,
  lists,
  userConnections,
  userConnectionLists
};

export const buildStore = (preloadedState?: PreloadedState) => configureStore({ reducer, preloadedState });

export type AppStore = ReturnType<typeof buildStore>;
export type AppDispatch = AppStore['dispatch'];
export type RootState = ReturnType<AppStore['getState']> & { context?: Context };

// these are intended to use within the app only
export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = (selector: (state: RootState) => any) =>
  useSelector<RootState, any>(selector, shallowEqual);
